import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import patternBg from '../../assets/images/bg-3938.jpeg';
import iconone from '../../assets/images/img-3928.jpeg';
import icontwo from '../../assets/images/img-3827.jpeg';
import selectArrow from '../../assets/images/select-arrow.png';

export const batchBanner = css`
  display: block;
  width: 100%;
  position: relative;
  padding: 0px 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
    margin-bottom: 0;
  }
  img {
    width: 100%;
  }
  span {
    width: 100%;
    max-width: 330px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 767px) {
      text-align: center;
    }
    img {
      width: 100%;
      max-width: 330px;
      @media (max-width: 767px) {
        max-width: 150px;
      }
    }
  }
`;

export const batchTitle = css`
  text-align: center;
  padding: 50px 0;
  font-size: 36px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
  &:after {
    content: '';
    width: 65px;
    height: 4px;
    background: #edc224;
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translate(-50%);
    @media (max-width: 767px) {
      bottom: 18px;
    }
  }
`;

export const cardFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
      .newCard-add {
        border-color: #edc224;
      }
      .card-body {
        h4 {
          color: ${appColors.white} !important;
        }
      }
    }
    &:nth-child(03) {
      .card {
        border-color: #edc224;
        .card-body {
          h4 {
            color: #edc224;
          }
          .editevenbutton {
            background: #edc224;
          }
        }
      }
    }
    &:nth-child(04) {
      .card {
        border-color: #72ff6b;
        .card-body {
          h4 {
            color: #72ff6b;
          }
          .editevenbutton {
            background: #72ff6b;
          }
        }
      }
    }
    &:nth-child(05) {
      .card {
        border-color: #2b3cdd;
        .card-body {
          h4 {
            color: #2b3cdd;
          }
          .editevenbutton {
            background: #2b3cdd;
          }
        }
      }
    }
  }
  .card {
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 190px;
        margin: auto;
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
    }
  }
`;

export const editBtn = css`
  background: transparent;
  width: 25px;
  padding: 0;
  float: right;
  margin-bottom: 8px;
  &:hover {
    background: transparent;
  }
  img {
    width: 30px;
  }
`;

export const batchesCols = css``;

export const editBatchesMain = css`
  width: 100%;
  max-width: 560px;
  margin: auto;
  padding: 40px 0;
  padding-bottom: 10px;
  position: relative;
  @media (max-width: 992px) {
    margin-top: 50px;
    @media (max-width: 767px) {
      margin-top: -20px;
      padding: 40px 15px 15px;
    }
  }
  h3 {
    text-align: center;
    font-family: Fredoka one, sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #000;
  }
  .add-item-box {
    display: block;
    margin-bottom: 20px;
    position: relative;
    .item-list {
      display: flex;
      align-items: center;
      margin-top: 10px;
      // margin-left: -5px;
      // margin-right: -5px;
      .item-container {
        padding: 5px;
        .item-name {
          font-size: 13px;
          font-weight: 400;
          background-color: ${appColors.orange};
          padding: 2px 6px 2px 2px;
          color: ${appColors.white};
          border-radius: 4px;
        }
        .closeBtn {
          color: ${appColors.orange};
          display: inline-block;
          width: 16px;
          height: 16px;
          text-align: center;
          border-radius: 4px;
          font-size: 10px;
          line-height: 17px;
          background-color: ${appColors.white};
          margin-right: 4px;
        }
      }
    }
    .custom-dropdown {
      width: 100%;
      &:before {
        display: none;
      }
      &:after {
        display: none;
      }
    }
    label {
      display: block;
      width: 100%;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 600;
    }
    input,
select {
  width: 100%;
  height: 50px;
  border: 1px solid ${appColors.gray800};
  border-radius: 5px;
  color: #636363;
  font-weight: normal;
  padding: 0 20px;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
}

select {
  background: ${appColors.white};
  background-image: url(${selectArrow});
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 97%;
}

  }
`;

export const addBtn = css`
  cursor: pointer;
  position: absolute;
  right: 3px;
  top: 3px;
  display: inline-block;
  width: 50px;
  height: 44px;
  background: ${appColors.orange};
  text-align: center;
  line-height: 45px;
  font-size: 18px;
  color: ${appColors.white};
  border-radius: 3px;
`;

export const editBtnFlex = css`
  display: flex;
  justify-content: center;
  .popupbutton2 {
    min-width: inherit;
    width: 100%;
    max-width: 140px;
    text-align: center;
    padding: 12px 12px;
    margin: 5px 8px;
    text-transform: uppercase;
    font-size: 14px;
    background: #dd6e2b;
    border-radius: 7px;
    &:nth-child(01) {
      background: #edc224;
    }
    &:hover {
      background: ${appColors.gray500};
    }
  }
`;

export const editBatchIcon = css`
  width: auto;
  height: auto;
  background: ${appColors.white};
  border-radius: 50%;
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    position: inherit;
    transform: inherit;
    margin: auto;
    top: inherit;
    left: inherit;
    width: auto;
    height: auto;
  }
  img {
  padding: 15px;
    width: 75px;
  }
`;
